import React, { useEffect, useState } from "react";
import { useParams,Link, useLocation } from 'react-router-dom';
import "./sangam.css";
import { useDispatch, useSelector } from "react-redux";
import ModalPopup from "./SangamModalPopup";
import axios from "axios";
import { API_BASE_URL,checkTime } from "../constant/constant";
import { msgPromtsuccess,loaderActionSlice,update_user_bal } from "../features/userSlice";
import IconWithRoundedBorder from "./borderCir/BoderCir";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";



const SangamComponent = () => {
    
    const [formData, setFormData] = useState({
        openPanna: "",
        closeDigit: "",
        closePanna: "",
        openDigit: "",
        points: "",
      });
      const [elementWrap, setElementWrap] = useState({
        openPanna: false,
        closeDigit: false,
        closePanna: false,
        openDigit: false,
        points: false,
      });
      const [error, setError] = useState({
        openPanna: "",
        closeDigit: "",
        closePanna: "",
        openDigit: "",
        points: "",
      });
      
      const [rows, setRows] = useState([]);
      const today = new Date();
      const dispatch=useDispatch();
      const { gameName } = useParams(); // Access the dynamic parameter
      const [myBidsErrors, setMyBidsErrors] = useState({});
      const [isModalOpen, setIsModalOpen] = useState(false);
      const formattedDate = (today.getMonth() + 1).toString().padStart(2, '0') + '/' + today.getDate().toString().padStart(2, '0') + '/' + today.getFullYear();
      const location = useLocation();
      const {Info,all_games}=useSelector((state)=>state.users);

      // Extract the last segment from the URL
      const lastSegment = location.pathname.split("/").filter(Boolean).pop();


      useEffect(()=>{
        if(lastSegment && lastSegment==='full_sangam'){
            setElementWrap({...elementWrap,openPanna:true,closePanna:true});

        }else{
            setElementWrap({...elementWrap,openPanna:true,closeDigit:true});

        }
      },[]);
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };

      const isValidInteger = (value) => {
        const number = Number(value);
        return Number.isInteger(number);
      };
      function validateSingleDigit(input) {
        // Convert input to a number to remove leading zeros and ensure it's numeric
        const number = parseInt(input, 10);
        // Check if it's a valid single digit (0–9)
        if (!isNaN(number) && number >= 0 && number <= 9) {
          return number || '0'; // Return the valid single digit
        } else {
          return null; // Invalid input
        }
      }
      const panaValidation=(val,name)=>{

        if(name==='closeDigit' || name==='openDigit'){
            if(!validateSingleDigit(val)){
                setError((prevState) => ({...prevState,[name]:"Please enter a valid number."}));
            }else{
                setError((prevState) => ({...prevState,[name]:""}));
                return validateSingleDigit(val);
            }
        }else{
        //console.log(val,name,isValidInteger(val),!val);
        const inputValue = val;
        // Check if the input is numeric and within 3 digits
        if (/^\d{0,3}$/.test(inputValue)  && isValidInteger(val) && val ) {
          setError((prevState) => ({...prevState,[name]:""}));
          return true;
        } else {
            setError((prevState) => ({...prevState,[name]:"Please enter a valid number."}));
            return false;
        }
    }
      }
      const  sumOfDigits=(number)=> {
        return number
          .toString() // Convert number to string
          .split("") // Split string into individual digits
          .map(Number) // Convert each character back to a number
          .reduce((acc, digit) => acc + digit, 0) % 10 || '0'; // Sum up the digits
      }
      function convertToThreeDigits(number) {
        return number.toString().padStart(3, "0");
      }
    
      const handleAdd = () => {
       if(formData.points<10){
                       dispatch(msgPromtsuccess({msg:`Please Enter minimum 10 Points.`,error:true}));
                       return false
                   }

        let sangam='';
        let openPanaSum=panaValidation(formData.openPanna,'openPanna') ?sumOfDigits(formData.openPanna):false;
        let closePanaSum=panaValidation(formData.closePanna,'closePanna') ?sumOfDigits(formData.closePanna):false;
        let openDigit=panaValidation(formData.openDigit,'openDigit')
        let closeDigit=panaValidation(formData.closeDigit,'closeDigit')
        let points=formData.points;
        let bidsData={};
        if(lastSegment ==='full_sangam'){
            if(openPanaSum && closePanaSum){
                sangam = `${convertToThreeDigits(formData.openPanna)}-${openPanaSum}${closePanaSum}-${convertToThreeDigits(formData.closePanna)}`;
                bidsData={openPanna:convertToThreeDigits(formData.openPanna),closePanna:convertToThreeDigits(formData.closePanna),openDigit:openPanaSum,closeDigit:closePanaSum};
            }else{
                return false;
            }
        }else{

            if(elementWrap.openPanna && elementWrap.closeDigit){
                if(closeDigit){
                sangam = `${convertToThreeDigits(formData.openPanna)}-${openPanaSum}${closeDigit}`;
                bidsData={openPanna:convertToThreeDigits(formData.openPanna),closePanna:'',openDigit:openPanaSum,closeDigit:closeDigit};
                }else{
                    return false;
                }
            }else if(elementWrap.closePanna && elementWrap.openDigit){
                if(openDigit){
                sangam = `${openDigit}${closePanaSum}-${convertToThreeDigits(formData.closePanna)}`;
                bidsData={openPanna:'',closePanna:convertToThreeDigits(formData.closePanna),openDigit:openDigit,closeDigit:closePanaSum};
                }else{
                    return false;
                }
            }else{
                return false;
            }
        }
          setRows([
            ...rows,
            {
              sangam: sangam,
              points: points,
              gameType: "open",
              dataAry:bidsData,
              error:''
            },
          ]);
          setFormData({
            openPanna: "",
            closeDigit: "",
            closePanna: "",
            openDigit: "",
            points: "",
          });
        
      };
      const closeModal = () => {
        setIsModalOpen(false);
      };
    
      const handleDelete = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);
      };
      const changeSangam=()=>{
        if(lastSegment && lastSegment!=='full_sangam'){
            if(!elementWrap.closePanna && !elementWrap.openDigit){
                setElementWrap({closePanna:true,openDigit:true,openPanna:false,closeDigit:false});
            }else{
                setElementWrap({closePanna:false,openDigit:false,openPanna:true,closeDigit:true});
            }
        }
      }
      const toTitleCase=(str)=>{
        return str
          .toLowerCase() // Convert the entire string to lowercase
          .split(/\s+/) // Split the string by spaces
          .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
          .join(" "); // Join the words back together with a single space
      }

      const handleSubmit = async() => {
        //debugger;
        dispatch(loaderActionSlice(true));
        let remain_ammount=false;
        let userAccountZero=false;
         await rows.reduce(async (previousPromise,value, key) => {
            // Wait for the previous request to finish
             console.log(value);
            await previousPromise;
              let dataObject={
                  'phone_number':Info?.phone_number,
                  'game_name':toTitleCase(gameName.split('_').join(' ')),
                  'game_type':toTitleCase(lastSegment?.split('_').join(' ')),
                  'session':'Open',
                  'open_pana':(convertToThreeDigits(value.dataAry.openPanna) && value.dataAry.openPanna) ?convertToThreeDigits(value.dataAry.openPanna) : 'NA',
                  'open_digit':value.dataAry.openDigit || 'NA',
                  'close_pana':(convertToThreeDigits(value.dataAry.closePanna) && value.dataAry.closePanna)? convertToThreeDigits(value.dataAry.closePanna): 'NA',
                  'close_digit':value.dataAry.closeDigit || 'NA',
                  'points_action':value.points,
              }


              try {
                // Send POST request
                let msgWitherror={...rows[key],error:'LOADING...'};
                let oldData=[...rows];
                oldData[key]=msgWitherror;
                setRows((prev)=>([...oldData]));
                     const response = await axios.post(
                        `${API_BASE_URL}set_bid_new.php`, // Replace with your PHP endpoint
                        new URLSearchParams({
                          bids: JSON.stringify([dataObject]), // Convert bids array/object to a JSON string
                        }),
                        {
                          headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                          },
                        }
                      );
               
                if(response.data.success && response.data.success!=='0'){
                    let msgWitherror={...rows[key],error:'Success'};
                    let oldData=[...rows];
                    oldData[key]=msgWitherror;
                    setRows((prev)=>([...oldData]));
                        remain_ammount=response.data?.Remaining_user_balance || false; 
                        if(response.data?.Remaining_user_balance===0){
                            userAccountZero=true;
                        }                   
                }else{
                    let error=response?.data?.msg || 'Failed';
                    let msgWitherror={...rows[key],error:error};
                    let oldData=[...rows];
                    oldData[key]=msgWitherror;
                    setRows((prev)=>([...oldData]));


                }
              } catch (error) {
                    let msgWitherror={...rows[key],error:'Failed'};
                    let oldData=[...rows];
                    oldData[key]=msgWitherror;
                    setRows((prev)=>([...oldData]));

              }finally{
                dispatch(loaderActionSlice(false));
              }

            }, Promise.resolve());        
            
          if(remain_ammount || userAccountZero){
             dispatch(update_user_bal(userAccountZero?0:remain_ammount));
          }
    };
    
      return (
        <div className="all_bids" style={{backgroundColor:'#ffffff'}}>
           <div className="header" style={{justifyContent:'space-between'}}>
           <input style={{width:'46%',boxShadow:'rgb(189, 189, 189) 5px 5px 5px'}} type="text" value={formattedDate} className="date-input" readOnly />
           {lastSegment!=='full_sangam'?<input placeholder="Change"  onClick={changeSangam} style={{width:'46%',boxShadow:'rgb(189, 189, 189) 5px 5px 5px'}} type="text"  className="date-input" readOnly />:''}
        </div>
        <div className="points-section" style={{textAlign:'left',paddingLeft:'6%'}}>
        {elementWrap.openPanna?<input placeholder={'Open Pana'}
            value={formData.openPanna} 
            style={{width:'46%',boxShadow:'rgb(189, 189, 189) 5px 5px 5px'}}
            type="number"
            name="openPanna"
            onChange={handleChange}
            className="date-input"
         />:''}
         {elementWrap.closePanna?<input placeholder={'Close Pana'}
            value={formData.closePanna} 
            style={{width:'46%',boxShadow:'rgb(189, 189, 189) 5px 5px 5px'}}
            type="number"
            name="closePanna"
            onChange={handleChange}
            className="date-input"
         />:''}
         {elementWrap.closeDigit?<input placeholder={'Close Digit'}
            value={formData.closeDigit} 
            style={{width:'46%',boxShadow:'rgb(189, 189, 189) 5px 5px 5px'}}
            type="number"
            name="closeDigit"
            onChange={handleChange}
            className="date-input"
         />:''}
         {elementWrap.openDigit?<input placeholder={'Open Digit'}
            value={formData.openDigit} 
            style={{width:'46%',boxShadow:'rgb(189, 189, 189) 5px 5px 5px'}}
            type="number"
            name="openDigit"
            onChange={handleChange}
            className="date-input"
         />:''}          
        </div>
        <div className="points-section" style={{textAlign:'left',paddingLeft:'6%'}}>
          <input placeholder="Enter points"
              value={formData.points}
              style={{width:'46%',boxShadow:'rgb(189, 189, 189) 5px 5px 5px'}} 
              type="number"
              className="date-input"
              onChange={handleChange}
              name='points' 
           />
        </div>
        <div className="add_body" style={{textAlign:'right',paddingRight:'8%'}}>
            <button className="continue-button" style={{width:'39%'}}  onClick={handleAdd}>
              ADD BID
            </button>
          </div>
         
          <div className="bids_table_div" style={{maxHeight:'300px',overflowY:'auto'}}>
            <div className="table_header_bid">
                <div>Pana</div>
                <div>Points</div>
                <div>Action</div>
            </div><br/>
            {rows.map((bid, index) => (
            <div className="table_content_bid" key={index}>
                <div>{bid.sangam}</div>
                <div>{bid.points}</div>
                <div onClick={() => handleDelete(index)} style={{cursor:'pointer'}}>
                 <IconWithRoundedBorder boxColor={'#BDBDBD'} innerColor={'#007bff'} outerColor={'#007bff'} FonCompo={<FontAwesomeIcon icon={faClose} color="white" size='1x'/>} />
                </div>
            </div>
           ))}
          </div><br/>
          <div className="button_container">
          <div className="footerBid" >
            <span className="footerBid_span">{rows.length}</span>
            <span style={{color:'gray'}}>Bids</span>
          </div>
          <div className="footerBid">
            <span className="footerBid_span">{rows.reduce((acc, value) => acc + parseInt(value.points), 0)}</span>
            <span style={{color:'gray'}}>Points</span>
          </div>
              <button  style={{width:'40%'}}  className="continue-button" onClick={()=>setIsModalOpen(true)}>
            Submit BID
          </button>
        </div>
          <ModalPopup 
         isOpen={isModalOpen}
         closeModal={closeModal} 
         betData={rows} 
         session={'Open'}
         gameName={gameName}
         handleSubmit={handleSubmit}
         myBidsErrors={myBidsErrors}
         /><br/><br/><br/><br/>
        </div>
      );
};


export default SangamComponent;
